"use client"

import * as React from "react"

const ShieldCanvas = React.lazy(() =>
  import("@/components/visuals/shield-canvas").then((mod) => ({
    default: mod.ShieldCanvas,
  })),
)

export function HeroShieldVisual() {
  return (
    <div className="relative mx-auto aspect-square w-full max-w-md lg:max-w-none">
      <div className="cyber-border absolute inset-0 overflow-hidden rounded-3xl bg-black/30">
        <React.Suspense
          fallback={
            <div className="flex h-full min-h-[280px] items-center justify-center">
              <div className="size-32 animate-pulse rounded-full bg-sky-500/10 ring-1 ring-sky-500/20" />
            </div>
          }
        >
          <ShieldCanvas />
        </React.Suspense>
      </div>
      <div
        className="pointer-events-none absolute -inset-4 rounded-[2rem] bg-sky-500/5 blur-2xl"
        aria-hidden="true"
      />
    </div>
  )
}
